import React, { useState } from "react";
import {
  VoucherContainer,
  ShoppingCartContainer
} from "../../containers/gamification2026";
import { t, ArrowLeftLG, withContainers } from "../normalizer";
import CustomButton from "../shared/CustomButton";
import VoucherDetail from "./VoucherDetail";
import VoucherActionBar from "./VoucherActionBar";
import VoucherConfirmModal from "./VoucherConfirmModal";
import VoucherHelpModal from "./VoucherHelpModal";

const Voucher = (props) => {
  const { voucher, onArchive, onGoHome, onReorderProduct, history } = props;
  // Help text comes from campaign config if available, otherwise i18n fallback.
  const helpText = voucher && voucher.voucher_type ? voucher.voucher_type.terms_text : "";

  // The user vouchers endpoint nests the product under `voucher_type`; older
  // payloads expose it flat, so both shapes are read before giving up.
  const voucherProduct =
    (voucher &&
      ((voucher.voucher_type && voucher.voucher_type.product) ||
        voucher.product)) ||
    null;
  const voucherProductId =
    (voucherProduct && voucherProduct.id) ||
    (voucher && voucher.product_id) ||
    null;
  const voucherProductName = voucherProduct && voucherProduct.name;

  // "Reencomendar": empties the cart, adds the voucher's product (one unit)
  // and redirects to /cart. The promise is handed back to the confirmation
  // modal so it can render the backend success/error message.
  const handleReorder = () => {
    if (!voucherProductId) return Promise.reject(new Error("missing product"));
    return onReorderProduct(voucherProductId, voucherProductName);
  };

  // Only one modal is ever open; null means none.
  const [activeModal, setActiveModal] = useState(null);
  const close = () => setActiveModal(null);

  // Confirmation copy is backend-sourced when present, with an i18n fallback.
  const reorderPrompt =
    (voucher && (voucher.reorder_message || voucher.reorder_confirmation)) ||
    t("gamification2026.voucher.reorder.prompt");
  const archivePrompt =
    (voucher && (voucher.archive_message || voucher.archive_confirmation)) ||
    t("gamification2026.voucher.archive.prompt");

  return (
    <div className="voucher-layout">
      <CustomButton
        link
        tight
        onClick={() => history.goBack()}
        className="voucher-layout-back"
      >
        <ArrowLeftLG className="voucher-layout-back-icon" />
        {t("gamification2026.voucher.back")}
      </CustomButton>
      <div className="voucher-layout-header">
        <h4 className="voucher-layout-header-title">
          {t("gamification2026.voucher.title")}
        </h4>
      </div>

      <div className="voucher-layout-container">
        <VoucherDetail voucher={voucher} />
        <VoucherActionBar
          onReorderClick={() => setActiveModal("reorder")}
          onArchiveClick={() => setActiveModal("archive")}
          onHelpClick={() => setActiveModal("help")}
          archiveDisabled={!!(voucher && voucher.archived)}
        />
      </div>

      <VoucherConfirmModal
        show={activeModal === "reorder"}
        title={t("gamification2026.voucher.reorder.title")}
        promptMessage={reorderPrompt}
        confirmLabel={t("gamification2026.voucher.actions.reorder")}
        onConfirm={handleReorder}
        onClose={close}
        onSuccessOk={onGoHome}
      />

      <VoucherConfirmModal
        show={activeModal === "archive"}
        title={t("gamification2026.voucher.archive.title")}
        promptMessage={archivePrompt}
        confirmLabel={t("gamification2026.voucher.actions.archive")}
        onConfirm={onArchive}
        onClose={close}
        onSuccessOk={onGoHome}
      />

      <VoucherHelpModal
        show={activeModal === "help"}
        onClose={close}
        helpText={helpText}
      />
    </div>
  );
};

export default withContainers(Voucher, [VoucherContainer, ShoppingCartContainer]);
